import React from "react";
import { Grid, Autocomplete, TextField } from "@mui/material";
import { IOrderStatus, IOrdersFiltersHeader } from "../../interfaces/order";
import { getOrderStatus } from "../../utils/orders";

const StatusFilterSelect = ({
  v2Enabled,
  statusList,
  selectedStatus,
  setSelectedStatus,
  selectedStatuses,
  setSelectedStatuses,
  handleChangeFilter,
}: {
  v2Enabled: boolean;
  statusList: IOrderStatus[];
  selectedStatus: string;
  setSelectedStatus: React.Dispatch<React.SetStateAction<string>>;
  selectedStatuses: IOrderStatus[];
  setSelectedStatuses: React.Dispatch<React.SetStateAction<IOrderStatus[]>>;
  handleChangeFilter: IOrdersFiltersHeader["handleChangeFilter"];
}) => (
  <Grid item xs={12} md={6} lg={v2Enabled ? 3 : 2}>
    {v2Enabled ? (
      <Autocomplete
        multiple
        id="status-multiple"
        options={statusList}
        value={selectedStatuses}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        noOptionsText="No se encontró el estado"
        onChange={(_, values) => {
          setSelectedStatuses(values);
          const ids = values.map((v) => v.id);
          handleChangeFilter("status", ids);
        }}
        renderInput={(params) => (
          <TextField {...params} fullWidth size="small" label="Estados" />
        )}
      />
    ) : (
      <Autocomplete
        id="status"
        inputValue={selectedStatus}
        options={statusList}
        noOptionsText="No se encontró el estado"
        onChange={(_, value: IOrderStatus | null, reason: string) => {
          const id = value?.id;
          handleChangeFilter("status", id);
          const label = id ? getOrderStatus(id)?.label || "" : "";
          setSelectedStatus(reason === "clear" ? "" : label);
        }}
        renderInput={(params) => (
          <TextField {...params} fullWidth size="small" label="Estado" />
        )}
      />
    )}
  </Grid>
);

export default StatusFilterSelect;
